import { Platform } from "react-native";

import { getStoredClubSlug } from "../clubSlugStorage";
import { STAFF_USER_CONTEXT } from "../constants";

/** Resolve once per environment so HTTP and subscriptions share one context. */
export const resolveAccessContext = async (
  clubSlug?: string,
  useStoredClubSlug = true,
  useStoredStaffContext = true
): Promise<string | null> => {
  if (clubSlug) return clubSlug;

  if (Platform.OS === "web") {
    // The destination URL wins over another tab's persisted selection, including STAFF.
    const match = window.location.pathname.match(
      /^\/patron\/(?:nonav\/)?club\/([^/]+)/
    );
    if (match) {
      try {
        return decodeURIComponent(match[1]);
      } catch {
        // An invalid destination must not select an unrelated saved context.
        return null;
      }
    }
  }

  // Ignore stale saved selections during bootstrap, but honor an explicit destination.
  if (!useStoredClubSlug) return null;

  // TODO(ENG-2770): Remove no-context compatibility once all supported clients select a context.
  const storedContext = await getStoredClubSlug();
  return !useStoredStaffContext && storedContext === STAFF_USER_CONTEXT
    ? null
    : storedContext;
};
